import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { CustomFormGroup } from '../../../shared/components';
import { defaultMessages } from '../../../libs/i18n/default';
import { Checkbox, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

const RegistrationInstitution = ({
  content = {}, place, territory, invalidatePlace, formatMessage, placeUnknown, setPlaceUnknown, handlePlaceSearch
}) => {
  const { guest_place_optional, guest_address_check, guest_types } = territory
  const showPlaceField = !guest_place_optional || (guest_address_check && place.val) || !placeUnknown
  const guest_kind_unknown_place = useSelector(state => state.guest_kind_unknown_place)
  const affiliate = useSelector(state => state.affiliate)
  const [idpAffiliate, setIdpAffiliate] = useState(false)

  // NOTE: Will be used in a future story
  // const [checkingAffiliate, setCheckingAffiliate] = useState(false)
  // const [affiliatedPlace, setAffiliatedPlace] = useState(null)

  const updatePlaceUnknown = () => {
    if (placeUnknown) {
      invalidatePlace()
      $('#placeSearch').val('')
    }
    setPlaceUnknown(!placeUnknown)
  }

  const label = () => {
    if (guest_kind_unknown_place) {
      return formatMessage(defaultMessages.clientGuestPagesRegisterLabelsCitySearchRequired)
    } else if (placeUnknown) {
      return formatMessage(defaultMessages.clientGuestPagesRegisterLabelsCitySearch)
    } else if (idpAffiliate) {

      return formatMessage(defaultMessages.clientGuestPagesRegisterLabelsPlaceSearchAffiliatePartner)
    } else {
      return ReactHtmlParser(formatMessage(
        defaultMessages.clientGuestPagesRegisterLabelsPlaceSearch,
        { country_name: territory.country_name }
      ))
    }
  }

  const showFallback = place.id === '-1' || place.id === -1 || place.google === true;

  useEffect(() => {
    if (!showFallback) return;

    let fallbackAutocomplete;
    const initFallback = () => {
      const element = document.getElementById('fallbackAutocomplete');
      if (!element || !window.google || !window.google.maps || !window.google.maps.places) return;

      if (element.getAttribute('data-initialized')) return;
      element.setAttribute('data-initialized', 'true');

      fallbackAutocomplete = new window.google.maps.places.Autocomplete(
        element,
        { types: [], componentRestrictions: { country: territory.country_code } }
      );

      fallbackAutocomplete.addListener('place_changed', () => {
        const gPlace = fallbackAutocomplete.getPlace();
        if (gPlace && gPlace.place_id) {
          if (handlePlaceSearch) {
            handlePlaceSearch({
              label: gPlace.name,
              value: gPlace.place_id,
              google: true
            });
          }
        }
      });
    };

    let interval = setInterval(() => {
      if (window.google && window.google.maps && window.google.maps.places && document.getElementById('fallbackAutocomplete')) {
        clearInterval(interval);
        initFallback();
      }
    }, 500);

    return () => clearInterval(interval);
  }, [showFallback]);

  useEffect(() => {
    setPlaceUnknown(guest_kind_unknown_place)
  }, [])

  useEffect(() => {
    if (affiliate !== 'studentessentialsidp') return;

    setIdpAffiliate(true)
  }, [])

  // NOTE: This will be used in a future story
  // useEffect(() => {
  //   if (!affiliate) {
  //     setCheckingAffiliate(false)
  //     return;
  //   }

  //   setCheckingAffiliate(true)

  //   fetch(`/guests/signup/check_affiliate?code=${affiliate}`, {
  //     method: 'GET',
  //     credentials: 'same-origin',
  //     headers: {'X-Requested-With': 'XMLHttpRequest'}
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     setCheckingAffiliate(false)
  //     setAffiliatedPlace(data.place)
  //     console.log(data)
  //   })
  // }, [])

  // if (checkingAffiliate) return (
  //   <div class="loading-spinner">
  //     <span class="spinner"></span>
  //     <span class="text">Loading...</span>
  //   </div>
  // )

  return (
    <>
      {idpAffiliate && (
        <h4>
          {formatMessage(
            defaultMessages.clientGuestPagesRegisterLabelsAgentHeader,
            { partner: 'IDP' }
          )}
        </h4>
      )}

      {guest_place_optional && !guest_address_check && !guest_kind_unknown_place && (
        <FormGroup>
          <Checkbox
            checked={placeUnknown}
            onChange={updatePlaceUnknown}>
            I don't know the name of the education institution that I will be attending
          </Checkbox>
        </FormGroup>
      )}

      <CustomFormGroup field={place}>
        <ControlLabel htmlFor="placeSearch">{label()}</ControlLabel>
        <FormControl
          id='placeSearch'
          type="text"
          onChange={(e) => {
            invalidatePlace();
            if (e.target.value === '') {
              // If cleared manually, also hide fallback
              $('#placeSearch').val('');
            }
          }}
          readOnly={place.val && territory.guest_address_check ? true : false}
          placeholder="Search..." />
      </CustomFormGroup>

      {showFallback && (
        <FormGroup className="required" style={{ marginTop: '10px' }}>
          <ControlLabel>{content?.pages?.register?.labels?.education_institution_not_found || (formatMessage ? formatMessage(defaultMessages.clientCommonNotFound) : 'Not found')}</ControlLabel>
          <FormControl
            id='fallbackAutocomplete'
            type="text"
            placeholder="Search by name/address"
            required={true}
            onChange={(e) => {
              if (handlePlaceSearch && place.google) {
                // If they edit the fallback field manually, reset the place back to "Not Found" state
                handlePlaceSearch({
                  label: content?.pages?.register?.labels?.education_institution_not_found || (formatMessage ? formatMessage(defaultMessages.clientCommonNotFound) : 'Not found'),
                  value: '-1',
                  google: false
                });
              }
            }}
          />
        </FormGroup>
      )}

      <div className="alert alert-info" style={{ marginTop: 5, marginRight: 44 }}>
        <i className="fa fa-lightbulb pull-left" style={{ marginRight: 5 }} />
        <p>{formatMessage(defaultMessages.clientGuestPagesRegisterLabelsPlaceSearchNote)}</p>
      </div>
    </>
  )
}

export default RegistrationInstitution
